export default __webpack_public_path__ + "static/media/greeting26.a8251517.png";